import {Button, Grid, Typography} from '@logistics-frontend/blocks'
import React, {useState} from 'react'

import {ActionWebTips} from 'src/api/cargo-c2c'

import {useIsMobile} from '../../hooks'
import {WebTipsModalDesktop} from './desktop'
import {WebTipsModalMobile} from './mobile'
import {classes} from './WebTips.classes'

type Props = {
  webTipsAction: ActionWebTips
}

function WebTips({webTipsAction}: Props): React.ReactElement<Props> {
  const [payUrl, setPayUrl] = useState<string | undefined>(undefined)
  const [activeChoiceId, setActiveChoiceId] = useState<string>(webTipsAction.last_choice_id)
  const isMobile = useIsMobile()
  const WebTipsModalComponent = isMobile ? WebTipsModalMobile : WebTipsModalDesktop

  const closeHandler = () => setPayUrl(undefined)
  const openModalHandler = (payUrl: string | undefined, choiceId: string) => () => {
    setPayUrl(payUrl)
    setActiveChoiceId(choiceId)
  }

  return (
    <>
      <Grid alignItems="center" className={classes.root} size="s" wrap="nowrap" container>
        {webTipsAction.choices.map(choice => (
          <Grid key={choice.choice_id} item>
            <Button
              disabled={!webTipsAction.enabled}
              onPress={openModalHandler(choice.tips_payment_url, choice.choice_id)}
              px="m"
              py="s"
              variant={choice.choice_id === activeChoiceId ? 'action' : 'default'}
            >
              <Typography variant="caption1">{choice.title}</Typography>
            </Button>
          </Grid>
        ))}
      </Grid>
      {!!payUrl && <WebTipsModalComponent onClose={closeHandler} payUrl={payUrl} />}
    </>
  )
}

export default WebTips
